"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentCheckbox = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
require("./index.scss");
var ConsentCheckbox = function (props) { return (React.createElement("div", { className: "consent-checkbox" },
    React.createElement("div", { className: "consent-header" }, props.header),
    React.createElement("div", { className: "input-with-link" },
        React.createElement(sok_ui_1.InputV2, { type: "checkbox", "aria-label": "".concat(props.name, "-checkbox"), name: props.name, label: props.label, value: props.value, disabled: props.isDisabled, onChange: !props.isDisabled ? props.onChange : undefined }),
        props.link && (React.createElement("span", { className: "consent-link" },
            React.createElement("a", { href: props.link, target: "_blank" }, (0, translation_1.getLocalization)('common/here'))))))); };
exports.ConsentCheckbox = ConsentCheckbox;
